export const style = {
  box: {
    sx: {
      alignItems: 'center',
      display: 'flex',
      ml: 2,
    },
  },
  avatar: {
    sx: {
      height: 40,
      width: 40,
    },
  },
  icon: {
    backgroundColor: 'text.primary',
    fontSize: 'small',
  },
} as const;
